import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { RouteNotFoundComponent } from './components/app/route-not-found.component';
import { HomeComponent } from './components/home/home.component';
import { PersonProfileComponent } from './components/profile/person/person-profile.component';
import { PlaceProfileComponent } from './components/profile/place/place-profile.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { RouterHelperService } from './services/router-helper.service';

/**
 * From Angualar 2 docs:
 * A Routing Module separates routing concerns from its companion module. It typically:
 * # defines routes
 * # adds router configuration to the module's imports
 * # re-exports RouterModule
 * # adds guard and resolver service providers to the module's providers.
 * # is not concerned with feature module declarations
 * The name of the Routing Module should parallel the name of its companion module, using the suffix "Routing".For example,
 * FooModule in foo.module.ts has a routing module named FooRoutingModule in foo - routing.module.ts
 */

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: RouterHelperService.appBaseRoute.personProfile + '/:id/:name',
          component: PersonProfileComponent,
        },
        {
          path: RouterHelperService.appBaseRoute.personProfile + '/:id',
          component: PersonProfileComponent,
        },
        // If no parameteres passed then redirect to the home page
        {
          path: RouterHelperService.appBaseRoute.personProfile,
          redirectTo: '/',
          pathMatch: 'full',
        },
        {
          path: RouterHelperService.appBaseRoute.placeProfile + '/:id/:name',
          component: PlaceProfileComponent,
        },
        {
          path: RouterHelperService.appBaseRoute.placeProfile + '/:id',
          component: PlaceProfileComponent,
        },
        {
          path: RouterHelperService.appBaseRoute.placeProfile,
          redirectTo: '/',
          pathMatch: 'full',
        },
        {
          path: RouterHelperService.appBaseRoute.searchResults,
          component: SearchResultsComponent,
        },
        { path: '', component: HomeComponent },
        { path: '**', component: RouteNotFoundComponent }, // Page not found, can be a custom 404 component.
      ], // { relativeLinkResolution: 'legacy' }
      { useHash: true },
    ),
  ],
  exports: [RouterModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppRoutingModule {}
